import { PRODUCT_STATUS } from 'my-purchases/constants/productStatus'
import type { OrderLine } from 'my-purchases/types/purchaseCommon'

import { countItemsByStatus } from './product'

interface GetOutOfStockLabelProps {
	lines?: OrderLine[]
	outOfStockItems: number
}

export function getOutOfStockLabel({
	lines,
	outOfStockItems,
}: GetOutOfStockLabelProps) {
	const itemsOutOfStock = lines
		? countItemsByStatus(lines, PRODUCT_STATUS.OUT_OF_STOCK)
		: outOfStockItems

	if (itemsOutOfStock) {
		if (lines) {
			const missingPickingKey =
				itemsOutOfStock > 1
					? 'my_purchases.tracking.text.n_items_out_of_stock'
					: 'my_purchases.tracking.text.item_out_of_stock'

			return {
				statusMessage: missingPickingKey,
				statusMessagePlaceholders: {
					1: itemsOutOfStock,
				},
			}
		}
		return { statusMessage: 'myPurchases.online.details.productOutStock.label' }
	}
	return null
}
